import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/dropdown-menu/style/index.js
// module id = 189
// module chunks = 7